"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleType = void 0;
var ScheduleType;
(function (ScheduleType) {
    ScheduleType["Single"] = "single";
    ScheduleType["Weekly"] = "weekly";
    ScheduleType["FullWeek"] = "full_week";
})(ScheduleType = exports.ScheduleType || (exports.ScheduleType = {}));
